<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :use-tab-codes="['indoor-auditorium']"
    />

    <!--점검정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>구분</h5>
      <div class="writeGridContainer">
        <div v-if="isPrint" class="print-input text-right">{{ form.type }}</div>
        <div v-else>
          <vs-radio class="mr-4" vs-name="점검정보_구분" v-model="form.type" vs-value="상반기" color="secondary" :disabled="board.readonly">상반기</vs-radio>
          <vs-radio vs-name="점검정보_구분" v-model="form.type" vs-value="하반기" color="secondary" :disabled="board.readonly">하반기</vs-radio>
        </div>
      </div>
    </div>


    <!-- 주요 유해위험 요인 발생 및 조치현황 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="주요 유해위험 요인 발생 및 조치현황"
      :tableData="[
        { id: 'input1', title: '발생현황', type: 'text', placeholder: '00건물 난관파손', width: '30%'},
        { id: 'input2', title: '확인경위', type: 'text', placeholder: '신고/점검', width: '20%' },
        { id: 'input3', title: '조치사항', type: 'text', placeholder: '00~00까지 이용제한, 보수보강 공사진행(00천원)', width: '50%' },
        { id: 'input4', title: '보고(권한대행)', type: 'text', placeholder: '여/부', width: '20%' },
      ]"
      v-model="form.status"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    DateSelector,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      showPopup: false,
      form: {
        stdInfo: {},
        fileList: [],

        // 1~5월이라면 상반기, 6~12월이라면 하반기
        type: new Date().getMonth() < 5 ? '상반기' : '하반기',

        status: [{}, {}], // 1줄을 보여주기 위해 빈데이터 {} 추가
      },
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">

</style>
